// extracted by mini-css-extract-plugin
module.exports = {"noteError":"noteError__1Kqh5","token":"token__3T-TK","section":"section__3KmhU","btnDanger":"btnDanger__3aYll","consoleButtons":"consoleButtons__6OG6Z"};